/** Colunas do order by da pesquisa dos pacotes de campanhas */
export enum PacoteCampanhaSearchOrderBy {
    Codigo = 1,
    Nome = 2,
    NomeArea = 3,
    Situacao = 4,
    SobDemanda = 6,
    VigenciaRecorrente = 5
};
